import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="route-loading">
        <Loader2 className="animate-spin text-primary" size={28} />
      </div>
    );
  }
  if (!user) return <Navigate to="/iniciar-sesion" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/panel" replace />;
  return children;
}
